import * as React from 'react';
import { Link } from 'react-router-dom';

export default class AuthApplyList extends React.Component<{}, any> {
    public constructor(props: any) {
        super(props);
    }
    public render() {
        return (
            <div className="takeRecord">
                <ul>
                    <li><Link to={{pathname: '/authentication/applylist', search: 'type=0'}}>企业认证申请</Link></li>
                    <li><Link to={{pathname: '/authentication/applylist', search: 'type=4'}}>认证变更申请</Link></li>
                    <li><Link to={{pathname: '/authentication/applylist', search: 'type=1'}}>加入企业申请</Link></li>
                    <li><Link to={{pathname: '/authentication/applylist', search: 'type=2'}}>主账号变更申请</Link></li>
                </ul>
            </div>
        )
    }
}